import {ChangeDetectorRef, Component, ViewChild} from "@angular/core";
import {ModalService} from "app/core/services/modal.service";
import {FilterValueService} from "app/features/analytics/service/filter-value.service";
import {SavedFilterNodes, SavedFilterService} from "app/features/analytics/service/saved-filter.service";
import {DropDownComponent} from "app/shared/components/drop-down/drop-down.component";
import {ModalComponent} from "app/shared/components/modal/modal.component";
import {Subject} from "rxjs";
import {DefaultSavedReportService} from '../../../service/default-saved-report.service';
import {takeUntil} from "rxjs/operators";
import {omitDeep} from "@apollo/client/utilities";

@Component({
    selector: 'header-report-filters',
    templateUrl: './header-report-filters.component.html',
    styleUrls: ['./header-report-filters.component.scss']
})
export class HeaderReportFilters {
    
    filters: SavedFilterNodes[] = [];
    removingFilter: SavedFilterNodes = null;
    @ViewChild('modalComponent', {static: false}) modalComponent: ModalComponent;
    @ViewChild('dropDown', {static: false}) dropDown: DropDownComponent;

    placeholder = 'Selected filters no saved';

    selectedReport:SavedFilterNodes = null;

    private destroy$ = new Subject<void>();

    loading = false;

    constructor (
        public savedFilters: SavedFilterService,
        private modalService: ModalService,
        private val: FilterValueService,
        public defaultSavedReport: DefaultSavedReportService,
        private cd: ChangeDetectorRef,
    ) { }

    ngOnInit (): void {
        this.savedFilters.getSavedFilters()
        .pipe(takeUntil(this.destroy$))
        .subscribe(filters => {
            this.filters = filters;

            this.checkSelectedReport();
        })

        this.val.value$
            .pipe(takeUntil(this.destroy$))
            .subscribe(value => {
                this.checkSelectedReport();
            })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    checkSelectedReport() {
        const value = this.val.value$.value;
        if (value.savedReportId) {
            this.selectedReport = this.filters.find(filter => filter.id === value.savedReportId);
        }
    }

    openModal (id: ModalComponent, filter?: SavedFilterNodes) {
        this.modalService.open(id);
        this.removingFilter = filter;
    }

    closeDropdown (e: MouseEvent) {
        this.dropDown.onToggleBtnClick(e)
    }

    closeModal (id: ModalComponent) {
        this.modalService.close(id);
    }

    async approveRemove (id: ModalComponent) {
        this.modalService.close(id);
        const result = await this.savedFilters.delete(this.removingFilter);
        if (result && result?.reportFilters?.deleteFilters) {
            this.filters = this.filters.filter(filter => filter.id !== this.removingFilter.id);
        }
            
        if (this.selectedReport?.id === this.removingFilter.id) {
            this.selectedReport = null;
            this.val.value = omitDeep(this.val.value, 'savedReportId');
        }

        this.dropDown.toggleContent(false);
        this.removingFilter = null;
    }

    isDefaultReport (filterId: string) {
        return filterId === this.defaultSavedReport.defaultSavedReport;
    }

    selectSavedFilter (filter: SavedFilterNodes) {
        let filterWithNewDate = this.savedFilters.getFilterWithNewDate(filter);
        this.val.onGetNewFilterFromQuery(filterWithNewDate);
        this.dropDown.toggleContent(false);
    }

    makeDefaultSavedFilter (reportId: string, event) {
        event.stopPropagation();
        this.loading = true;

        const report = !this.isDefaultReport(reportId) ? reportId : '';
        this.defaultSavedReport.makeDefaultReport(report).subscribe(
            report => {
                console.debug('default report is saved!', report);
                this.loading = false;
                this.cd.detectChanges();
            },
            err => {
                console.error(err, 'failed setup default report!');
            }
        );
    }

    isSelectedFilters(filterId: string) {
        return this.val.value.savedReportId === filterId;
    }
}
